<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-stamp-fill`]" width="1em" height="1em" v-bind="$attrs"><path d="M41.102 27.414h-6.399c-1.419 0-2.7-.848-3.254-2.154l-2.19-5.162a1.895 1.895 0 01.492-2.153c2.163-1.942 3.336-4.962 2.647-8.224-.681-3.23-3.294-5.84-6.525-6.514-5.541-1.157-10.419 3.04-10.419 8.377 0 2.569 1.14 4.86 2.934 6.427.624.545.845 1.416.52 2.18l-2.15 5.069a3.535 3.535 0 01-3.254 2.154H6.897c-.96 0-1.738.778-1.738 1.738v6.81c0 .96.778 1.738 1.738 1.738h34.205c.96 0 1.739-.778 1.739-1.738v-6.809c0-.96-.778-1.739-1.739-1.739zm-.813 13.73H7.739a.866.866 0 00-.866.865v1.696c0 .479.388.867.867.867h32.549a.866.866 0 00.866-.867V42.01a.866.866 0 00-.866-.866z"/></svg>
</template>
<script>

export default {
  name: 'IconStampFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
